/* eslint-disable max-len */
export const organizationSchema = {
	"@context": "https://schema.org",
	"@type": ["Organization", "OnlineBusiness"],
	"@id": "https://www.storage.com/#organization",
	name: "Storage.com",
	url: "https://www.storage.com/",
	sameAs: [
		"https://www.linkedin.com/company/storage-com",
		"https://www.twitter.com/storagecom",
		"https://www.facebook.com/SelfStorageMarketplace/"
	],
	logo: {
		"@type": "ImageObject",
		url: "https://www.storage.com/images/sc-logo.svg"
	},
	description: "Storage.com is a self-storage marketplace where you can easily browse and compare all storage facilities and units in your area. Reserve online for free with no credit card required.",
	contactPoint: {
		"@type": "ContactPoint",
		telephone: "1-833-448-1067",
		contactType: "Sales"
	},
	founder: {
		"@type": "Person",
		name: "Chuck Gordon"
	},
	foundingDate: "2008"
};

export const websiteSchema = {
	"@context": "http://schema.org",
	"@type": "WebSite",
	url: "https://www.storage.com",
	potentialAction: {
		"@type": "SearchAction",
		target: "https://www.storage.com/search?{search_term_string}",
		"query-input": "required name=search_term_string"
	}
};

export const generateCLPWebPageSchema = ({ city, state, canonicalUrl, title, description }) => ({
	"@context": "https://schema.org",
	"@type": "WebPage",
	"@id": `${canonicalUrl}#webpage`,
	name: title,
	url: `${canonicalUrl}`,
	description,
	isPartOf: {
		"@id": "https://www.storage.com/#website"
	},
	breadcrumb: {
		"@id": `${canonicalUrl}#breadcrumb`
	},
	mainEntity: {
		"@type": "Place",
		name: `${city}, ${state}`,
		hasMap: {
			"@type": "Map",
			name: `Map of ${city}, ${state} Storage Units`,
			url: `${canonicalUrl}#map`
		}
	}
});

export const generateCLPWebsiteSchema = ({ baseUrl }) => {
	const safeBaseUrl = baseUrl || "";

	return {
		"@context": "https://schema.org",
		"@type": "WebSite",
		"@id": "https://www.storage.com/#website",
		name: "Storage.com",
		url: `${safeBaseUrl}/`,
		publisher: {
			"@id": "https://www.storage.com/#organization"
		},
		potentialAction: {
			"@type": "SearchAction",
			target: {
				"@type": "EntryPoint",
				urlTemplate: `${safeBaseUrl}/search?location={search_term_string}`,
				inLanguage: "en-US",
				actionPlatform: [
					"http://schema.org/DesktopWebPlatform",
					"http://schema.org/MobileWebPlatform"
				]
			},
			"query-input": {
				"@type": "PropertyValueSpecification",
				valueRequired: "http://schema.org/True",
				valueName: "search_term_string"
			}
		}
	};
};
